import { GameSummary } from '@gamenight/common/dist/types';

export const getNewGames = (
  allGames: GameSummary[],
  currentGames: GameSummary[],
) =>
  allGames.filter(
    ({ bgg_id: id1 }) => !currentGames.some(({ bgg_id: id2 }) => id2 === id1),
  );
